<template>
  <div :class="['ms-form', { purpose: this.data?.body?.purpose }]">
    <q-form @submit="this.onSubmit">
      <!-- как в smremont: при групповом добавлении маржу не показываем, цена уйдёт на все выбранные строки -->
      <q-banner v-if="isBulk" class="info-banner">
        <strong>Выбрано позиций:</strong> {{ formData.material_provider_id_arr.length }}
      </q-banner>
      <q-banner v-else class="info-banner">
        <strong>Маржа FF (%):</strong> {{ material_marzha }}
      </q-banner>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-money-bill-wave" aria-hidden="true" />Цены в местной валюте</h3>
        <div class="ms-form-grid price-form__grid">
          <CustomInput
            label="Цена (розничная)"
            type="number"
            :value="formData.price"
            @change_input="(value) => onChange('price', value)"
          />
          <CustomInput
            label="Цена (оптовая)"
            type="number"
            :value="formData.price_whole"
            @change_input="(value) => onChange('price_whole', value)"
          />
          <CustomInput
            label="Цена (накладная)"
            type="number"
            :value="formData.invoice_price"
            @change_input="(value) => onChange('invoice_price', value)"
          />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-coins" aria-hidden="true" />Цены в валюте</h3>
        <div class="ms-form-grid price-form__grid">
          <CustomInput
            label="Цена (розничная)"
            type="number"
            :value="formData.currency_price"
            @change_input="(value) => onChange('currency_price', value)"
          />
          <CustomInput
            label="Цена (оптовая)"
            type="number"
            :value="formData.currency_price_whole"
            @change_input="(value) => onChange('currency_price_whole', value)"
          />
          <CustomInput
            label="Цена (накладная)"
            type="number"
            :value="formData.currency_invoice_price"
            @change_input="(value) => onChange('currency_invoice_price', value)"
          />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-calendar-days" aria-hidden="true" />Период действия</h3>
        <div class="ms-form-grid">
          <div class="price-form__date">
            <CustomDate
              label="Дата с"
              required
              :value="formData.date_begin"
              @change_date="(value) => onChange('date_begin', value)"
            />
          </div>
          <div class="price-form__date">
            <CustomDate
              label="Дата по"
              :value="formData.date_end"
              @change_date="(value) => onChange('date_end', value)"
            />
          </div>
          <CustomInput
            class="ms-form-wide"
            label="Комментарии"
            type="textarea"
            :value="formData.price_comment"
            @change_input="(value) => onChange('price_comment', value)"
          />
        </div>
      </section>

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomDate from "@/components/form/CustomDate";
import CustomInput from "@/components/form/CustomInput";

export default {
  name: "material-list-add-price",
  components: { CustomModalFooter, CustomDate, CustomInput },
  props: ["data"],
  data() {
    return {
      loading: false,
      material_marzha: this.data.body?.material_marzha ?? "",
      formData: {
        material_provider_id: this.data.body?.material_provider_id || "",
        material_provider_id_arr: this.data.body?.material_provider_id_arr || [],
        price: "",
        price_whole: "",
        invoice_price: "",
        currency_price: "",
        currency_price_whole: "",
        currency_invoice_price: "",
        date_begin: new Date().toLocaleDateString("ru"),
        date_end: "",
        price_comment: "",
      },
    };
  },
  computed: {
    isBulk() {
      return this.formData.material_provider_id_arr.length > 0;
    },
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.loading = true;
      await this.data?.onSubmit(this.formData);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
// Блоки, сетка и ширина — общие (ms-form-* в theme.scss)
.info-banner {
  margin-bottom: 8px;
  padding: 10px 12px;
  border-radius: var(--ms-radius-sm);
  background-color: var(--ms-primary-50);
  color: var(--ms-primary-ink);
  font-size: 13px;
}

.price-form {
  // три цены в ряд (на телефоне — одна колонка, как у ms-form-grid)
  &__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));

    @media (max-width: 768px) {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  // дата на всю ширину ячейки
  &__date :deep(.custom-date) {
    width: 100%;
    max-width: none;
  }
}
</style>
